import { SSOAPIContext } from 'helpers/context/ssoAPIContext';
import { IAPIContext, } from 'models/context/api-context';
import { SSOAPIContextParseFailure } from 'services/errors';
import { ClientResponse } from 'services/sso-api/client/client-response';

export class SSOAPIContextParser {
    public static getSSOAPIContextFromQueryParam(queryParam: string): IAPIContext {
        if (!queryParam) {
            throw new Error('Failed to retrieve context from query parameters.');
        }
        const decodedContext = decodeURIComponent(queryParam);
        return SSOAPIContextParser.parseStringToSSOAPIContext(decodedContext);

    }

    public static getSSOAPIContextFromResponse(response: ClientResponse): IAPIContext {
        const jsonStr = response.headers.get('sso-api-context');

        if (!jsonStr) {
            throw new Error('Failed to retrieve context from response headers.');
        }
        return SSOAPIContextParser.parseStringToSSOAPIContext(decodeURIComponent(jsonStr));

    }

    public static SSOAPIContextToQueryParam(context: IAPIContext): string {
        return encodeURIComponent(JSON.stringify(context));
    }

    private static parseStringToSSOAPIContext(str: string): IAPIContext {
        try {
            return SSOAPIContext.fromJsonToAPIContext(str);
        } catch (error) {
            throw new SSOAPIContextParseFailure('Failed to parse context from query parameters', { cause: error as Error });
        }
    }
}
